import React from 'react';

import Beeline from 'ati-ui-react/components/icons/Beeline';
import Megafon from 'ati-ui-react/components/icons/Megafon';
import MTS from 'ati-ui-react/components/icons/MTS';
import Tele2 from 'ati-ui-react/components/icons/Tele2';
import Rostelecom from 'ati-ui-react/components/icons/Rostelecom';

import Link from 'ati-ui-react/components/Link';
import { PhoneStyles, Text } from './PhoneStyles';

function Phone({ contact, mt, mw, wrap = false }) {
  const phoneBrands = {
    МТС: <MTS className="brand-icon" width={16} height={16} />,
    Теле2: <Tele2 className="brand-icon" width={16} height={16} />,
    МегаФон: <Megafon className="brand-icon" width={16} height={16} />,
    Ростелеком: <Rostelecom className="brand-icon" width={16} height={16} />,
    Билайн: <Beeline className="brand-icon" width={16} height={16} />,
  };
  const telephoneBrand = contact?.telephone_brand;
  const telephone = contact?.telephone;

  const mobileBrand = contact?.telephone_brand;
  const mobile = contact?.mobile;

  if (!telephone && !mobile) {
    return null;
  }

  return (
    <PhoneStyles isWrap={wrap} mw={mw} mt={mt} onClick={(e) => e.stopPropagation()}>
      {telephone && telephoneBrand && phoneBrands[telephoneBrand]}
      {telephone && (
        <Text>
          <Link href={`tel:${telephone}`} rel="noopener noreferrer">
            {telephone}
          </Link>
          {mobile && ', '}
        </Text>
      )}
      {mobile && mobileBrand && phoneBrands[mobileBrand]}
      {!!mobile && (
        <Text>
          <Link href={`tel:${mobile}`} rel="noopener noreferrer">
            {mobile}
          </Link>
        </Text>
      )}
    </PhoneStyles>
  );
}

export default Phone;
